import React from 'react';

interface Props {
  enabled: boolean;
  onToggle: () => void;
}

export default ({ enabled, onToggle }: Props) => (
  <div className="align-items-center d-flex gap-xs">
    <div
      onClick={onToggle}
      style={{
        background: enabled ? '#5cb85c' : '#ccc',
        borderRadius: 12,
        cursor: 'pointer',
        height: 16,
        position: 'relative',
        transition: 'background 0.2s',
        width: 28
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '50%',
          height: 12,
          left: enabled ? 13 : 3,
          position: 'absolute',
          top: 2,
          transition: 'left 0.2s',
          width: 12
        }}
      />
    </div>
    <div>{enabled ? 'Enabled' : 'Disabled'}</div>
  </div>
);
